import { useEffect } from 'react';

import type { AlineEditor, PlaywrightAdapter } from '@aline/common';
import {
  AlineTransforms,
  getPresenceColor,
  isCheckboxElement,
  isCheckboxOptionFieldElement,
  isInputFieldElement,
  isParagraphElement,
  isRenderModelLine,
  isRenderModelPage,
  Queries,
  SelEventSource,
} from '@aline/common';
import { Editor, Node, Text, Transforms } from 'slate';
import type { Range } from 'slate';
import { getSpellcheckStateForTabId } from 'src/editor/spellcheck-state-registry';
import { IS_PLAYWRIGHT } from 'src/helpers/environment';
import { EDITOR_TO_TAB_STATE } from 'src/layout-engine/utils/weak-maps';

declare global {
  interface Window {
    playwrightAdapter?: PlaywrightAdapter;
  }
}

export const usePlaywrightIfEnabled = IS_PLAYWRIGHT ? usePlaywright : () => {};

function usePlaywright(editor: AlineEditor) {
  useEffect(() => {
    window.playwrightAdapter = {
      AlineTransforms,
      Editor,
      Node,
      Queries,
      SelEventSource,
      Text,
      Transforms,
      editor,
      getPresenceColor,
      getSpellcheckRanges: () => {
        const live: Range[] = [];
        const rangeRefs =
          getSpellcheckStateForTabId(EDITOR_TO_TAB_STATE.get(editor)?.tabId ?? null)?.ranges ?? [];
        for (const rangeRef of rangeRefs) {
          if (rangeRef.current) live.push(rangeRef.current);
        }
        return live;
      },
      isCheckboxElement,
      isCheckboxOptionFieldElement,
      isInputFieldElement,
      isParagraphElement,
      isRenderModelLine,
      isRenderModelPage,
    };
  }, [editor]);
}
